import { RouteComponentProps } from 'react-router-dom';
import { parse } from '@tock/query-string';

import { IWithContextProps, safeToNumber, withContext } from '@tock/coretypes';
import BaseComponent from '@tock/shared/components/BaseComponent';
import connect, { DefaultConnectProps } from '@tock/shared/utils/connect';

class VerifyTransferRoute extends BaseComponent<
  DefaultConnectProps & RouteComponentProps & IWithContextProps
> {
  UNSAFE_componentWillMount() {
    if (BROWSER) {
      const { location } = this.props;
      const query = parse(location.search);
      if (!query.token) {
        this.props.actions.toast.showError('Invalid transfer link');
        this.props.history.push('/profile/reservations');
      }

      this.props.actions.app
        .loginWithTransferToken(query.token)
        .then(() => this.props.actions.transfer.verifyTransferToken(query.token))
        .then(this.getPurchase)
        .catch(this.continue);
    }
  }

  getPurchase() {
    const query = parse(this.props.location.search);
    this.props.actions.transfer
      .getPurchase(query.token)
      .then((response) => {
        this.props.history.push(`/profile/reservations/${safeToNumber(response.payload.id)}`);
      })
      .catch(this.continue);
  }

  continue() {
    this.props.history.push('/profile/reservations');
  }

  render() {
    return <span />;
  }
}

export default connect<RouteComponentProps>(withContext(VerifyTransferRoute));
